import { FormEvent, useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { CirclePicker } from 'react-color';


import { ProjectStageDto } from 'utils/wemble-api.generated';
import {
  useDeleteProjectStageMutation,
  useCreateProjectStageMutation,
  useUpdateProjectStageMutation,
} from 'utils/wemble-api';

const ProjectStageModal = ({
  isOpen,
  onClose,
  title,
  data,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  data?: ProjectStageDto | undefined;
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [name, setName] = useState(data?.name ?? '');
  const [color, setColor] = useState(data?.color ?? '75B7D8');
  const [removeProjectStage] = useDeleteProjectStageMutation();
  const [createProjectStage] = useCreateProjectStageMutation();
  const [updateProjectStage] = useUpdateProjectStageMutation();

  useEffect(() => {
    if (isOpen && data) {
      setName(data.name ?? '');
      setColor(data.color ?? '75B7D8');
    }
  }, [isOpen]);

  const resetState = () => {
    setName('');
    setColor('75B7D8');
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleSubmit = async (ev: FormEvent) => {
    setIsSubmitting(true);
    setErrorMsg(undefined);
    ev.preventDefault();
    let res;
    if (data && data._id) {
      res = await updateProjectStage({
        id: data._id,
        projectStageUpsertParams: {
          name,
          color,
        },
      });
    } else {
      res = await createProjectStage({
        projectStageUpsertParams: {
          name,
          color,
        },
      });
    }
    if ('error' in res) {
      const error = res.error as any;
      if (typeof error?.data?.message === 'string') {
        setErrorMsg(error?.data?.message);
      }
      setIsSubmitting(false);
      return;
    }
    setIsSubmitting(false);
    handleClose();
  };

  const handleDelete = () => {
    setIsSubmitting(true);
    if (!data?._id) return;
    removeProjectStage({
      id: data._id,
    });
    setIsSubmitting(false);
    handleClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose}>
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={handleClose}>{title}</ModalHeader>
        <ModalBody>
          <table className={'table'}>
            <tbody>
              <tr>
                <th scope="row" className={'control-label'}>
                  Name
                </th>
                <td>
                  <input
                    id="skill-name"
                    placeholder='Example: "Active"'
                    value={name}
                    type="text"
                    name="name"
                    required
                    className={'form-control'}
                    onChange={(ev) => setName(ev.target.value)}
                    disabled={isSubmitting}
                  />
                </td>
              </tr>
              <tr>
                <th scope="row" className={'control-label'}>
                  Color
                </th>
                <td>
                  <CirclePicker
                  color={color}
                  onChange={newColor=>setColor(newColor.hex)}
                  colors={["#75B7D8","#65C898","#EEC444", "#FF5454", "#9900EF", "#A1A5B7"]}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          {errorMsg && <span className="text-danger">{errorMsg}</span>}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>
          {data && (
            <Button color="danger" onClick={handleDelete} disabled={isSubmitting}>
              Delete
            </Button>
          )}
          <Button color="primary" type="submit" disabled={isSubmitting}>
            {data ? 'Save' : 'Add'}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default ProjectStageModal;
